import './TabPanel.scss';
import React, { memo, PropsWithChildren } from 'react';

export const TabPanel = memo(({ children }: PropsWithChildren) => (
  <div className="bp-tab-panel">{children}</div>
));
